(function(angular) {
    angular.module('bizPartEngage').provider('pageTitleNotification', pageTitleNotificationProvider);

    function pageTitleNotificationProvider() {
        var Vars = {
            OriginalTitle: document.title,
            Interval: null
        };

        function On(notification, intervalSpeed) {
            Vars.Interval = setInterval(function () {
                document.title = (Vars.OriginalTitle == document.title)
                    ? notification
                    : Vars.OriginalTitle;
            }, (intervalSpeed) ? intervalSpeed : 1000);
        }

        function Off() {
            clearInterval(Vars.Interval);
            document.title = Vars.OriginalTitle;
        }

        return {
            On: On,
            Off: Off,
            $get: function() {
                return {
                    On: On,
                    Off: Off,
                };
            }
        }
    }
})(window.angular);
